import { type ButtonProps } from '@pets-ui/Button/Button'
import { Button } from '@pets-ui/Button/Button'
import { Paper } from '@pets-ui/Paper/Paper'
import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '../../../hooks/useMediaQuery'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const styles = stylex.create({
  saveButton: {
    height: '40px',
    marginTop: {
      [MOBILE]: 0,
      default: '20px',
    },
    width: {
      [MOBILE]: '100%',
      default: '200px',
    },
  },
  paper: {
    padding: '8px',
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    position: 'fixed',
    zIndex: zIndex.appBar,
    bottom: 0,
    left: 0,
    width: '100%',
  },
})

export type SaveButtonProps = ButtonProps

export function SaveButton(props: SaveButtonProps) {
  const { t } = useTranslation()
  const mpUp = useMediaQuery('(min-width: 600px)')
  return (
    <div>
      {mpUp
        ? <Button rootStyle={styles.saveButton} {...props}>{t('login.save')}</Button>
        : (
          <Paper borderRadius={0} rootStyle={styles.paper} shadowDirection="top" elevation={8}>
            <Button rootStyle={styles.saveButton} {...props}>{t('login.save')}</Button>
          </Paper>
        )}
    </div>
  )
}
